const NO_SPOTIFY_KEY = 'banger.nospotify';

/**
 * Dev-only `?nospotify=1`: hosting skips the Spotify login and playback is a
 * no-op (the seed catalog's fake ids would otherwise all be reported unplayable).
 * Remembered for the tab in sessionStorage. Always false in production builds.
 */
export function noSpotify(): boolean {
  if (!import.meta.env.DEV) return false;
  try {
    if (new URLSearchParams(location.search).get('nospotify') === '1') sessionStorage.setItem(NO_SPOTIFY_KEY, '1');
    return sessionStorage.getItem(NO_SPOTIFY_KEY) === '1';
  } catch {
    return false;
  }
}
